import axios from "axios";

export function exportVoucherListing({ uuid, fileType, search, startDate, endDate, status }) {
  return new Promise((resolve, reject) => {
    axios.post(`/consumer/admin/api/v1/survey/vouchers/export`, {
      survey_uuid: uuid,
      file_type: fileType ?? 'xlsx',
    },{
      responseType: "blob",
    })
      .then(response => {
        let fileName = `export.${fileType ?? 'xlsx'}`;
        const disposition = response.headers['content-disposition'];
        if (disposition && disposition.indexOf('filename=') !== -1) {
          const matches = disposition.match(/filename="?([^";]+)"?/);
          if (matches && matches[1]) {
            fileName = matches[1];
          }
        }
        resolve({data: response.data, fileName});
      })
      .catch(error => reject(error.response.data))
  })
}
